import { useCustomTranslation } from "../../hooks/useCustomTranslation";

export const GalleryError = (): JSX.Element => {
  const { t } = useCustomTranslation("Notifications");
  return (
    <div className="gallery-notice-container">
      <div className="gallery-notice-container__content">
        <p>{t("SorryNothingHere")}</p>
        <p>{t("LinkExpired")}</p>
      </div>
    </div>
  );
};
